// https://github.com/moment/moment/issues/3650
import { halfYearFormatToMoment } from '../date-picker/utils';

export default function interopDefault(m, mode) {
  if (mode) {
    if (Array.isArray(mode) ? mode.includes('halfyear') : mode === 'halfyear') {
      return function (value, valueForm) {
        return halfYearFormatToMoment(m['default'] || m, value, valueForm);
      };
    }
  }
  return m['default'] || m;
}